export default __webpack_public_path__ + "static/media/key-tab.61114933.svg";